import React from "react";
import GooglePlayButton from "./../../components/GooglePlayButton";
import AppleButton from "./../../components/AppleButton";

export default function Footer() {
  return (
    <footer className="text-white m">
      <div className="container md:mx-32 mx-auto  px-16  sm:px-6 lg:px-8 py-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="mb-8 md:mb-0">
          <h4 className="text-xl font-bold mb-6">Quick Links</h4>
          <ul className="space-y-4">
            <li>
              <a className="hover:underline" href="#">
                About us
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Services
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Our Fleet
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Promo{" "}
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Thirdparty
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Contact{" "}
              </a>
            </li>
          </ul>
        </div>
        <div className="mb-8 md:mb-0">
          <h4 className="text-xl font-bold mb-6">Top cities</h4>
          <ul className="space-y-4">
            <li>
              <a className="hover:underline" href="#">
                Accra
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Kumasi
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Takoradi
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Cape Coast
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                HO
              </a>
            </li>
          </ul>
        </div>
        <div className="mb-8 md:mb-0">
          <h4 className="text-xl font-bold mb-6">Explore</h4>
          <ul className="space-y-4">
            <li>
              <a className="hover:underline" href="#">
                Self drive services
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Shuttle service
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Chauffeur service
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Meet & Greet service
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Tours
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Airport transfer
              </a>
            </li>
          </ul>
        </div>
        <div className="mb-8 md:mb-0">
          <h4 className="text-xl font-bold mb-6">Classes</h4>
          <ul className="space-y-4">
            <li>
              <a className="hover:underline" href="#">
                Executive Sedan
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Business SUV
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Luxury Sedan
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Executive SUV
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Standard Mini Coach
              </a>
            </li>
            <li>
              <a className="hover:underline" href="#">
                Standard Sedan
              </a>
            </li>
          </ul>
        </div>
        <div className="md:col-span-2 lg:col-span-1 lg:col-start-5">
          <h4 className="text-xl font-bold mb-6">Download The App</h4>
          <div className="flex flex-col space-y-4">
            <button className="text-black flex items-center justify-center space-x-2 py-2 px-4 rounded-md">
              <AppleButton />
            </button>
            <button className="text-black flex items-center justify-center space-x-2 py-2 px-4 rounded-md">
              <GooglePlayButton />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
